@for (option of options; track option) {
  <mat-checkbox
    [(ngModel)]="collectedBooleans[option.id]"
    (ngModelChange)="booleansChanged()">
    {{ option.name }}
  </mat-checkbox>
}